"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgCampaignViewed = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M30.736 21.834a.98.98 0 0 0-.203-.596c-1.005-1.326-3.79-4.4-7.797-4.4s-6.785 3.066-7.797 4.4a.975.975 0 0 0 0 1.192c1.01 1.32 3.79 4.4 7.797 4.4s6.785-3.067 7.797-4.4a.98.98 0 0 0 .203-.596m-6.89-1.664a2 2 0 1 0-2.222 3.327 2 2 0 0 0 2.223-3.327", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M3 2a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v4l4.364-3.276a1 1 0 0 1 1.2 1.6L5.6 31.8A1 1 0 0 1 4 31v-5H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v10a1 1 0 1 1-2 0V3a1 1 0 0 0-1-1z", clipRule: "evenodd" }),
    React.createElement("path", { fill: "#fff", fillOpacity: 0.48, fillRule: "evenodd", d: "M6 9.015a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1M6 14.015a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1M6 19.015a1 1 0 0 1 1-1h3a1 1 0 0 1 0 2H7a1 1 0 0 1-1-1", clipRule: "evenodd" })));
exports.default = SvgCampaignViewed;
